module.exports = __webpack_public_path__ + "static/sodexo.931306aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/sodexo.svg
// module id = 424
// module chunks = 221427640695397